export default __webpack_public_path__ + "cb542b603ad1da3cb6f8b6b3fa1b302c.png";